<template>
  <div class="sidebar-wrapper">
    <h3>
      Art Grab currently has {{ totalCount.photos }} unique images available to
      license for your next album cover, poster, or creative project.
    </h3>
    <hr />
    <h3 class="mt-4">Featured Artists</h3>
    <div
      class="featured-wrapper"
      v-for="artist in randomFeaturedArtists"
      v-bind:key="artist.id"
    >
      <div class="featured-avatar">
        <a :href="'/art/' + artist.handle"
          ><img :src="artist.profile_image"
        /></a>
      </div>
      <div class="featured-link">
        <a :href="'/art/' + artist.handle">@{{ artist.handle }}</a>
      </div>
    </div>
    <h3 class="mt-5">Fresh Artwork</h3>
    <div class="row" v-if="top12.length > 0">
      <div
        v-for="artwork in top12"
        :key="'fresh-artwork-' + artwork.id"
        class="col-4 featured-image"
      >
        <a
          :href="'/art/' + artwork.artist_handle.slice(1) + '/' + artwork.id"
          :style="'background-image: url(' + artwork.url_path + ')'"
        >
        </a>
      </div>
    </div>
    <h3 class="mt-5">Recent Posts</h3>
    <hr />
    <div v-if="posts.length > 0">
      <div
        class="recent-posts"
        v-for="item in posts.slice(0, 6)"
        v-bind:key="item.fields.postUrl"
      >
        <div class="date">{{ getDate(item.fields.date) }}</div>
        <router-link :to="'/blog/' + item.fields.postUrl">
          <h4>{{ item.fields.title }}</h4>
        </router-link>
        <p>
          {{ item.fields.snippet.substring(0, 120) }}...
          <router-link :to="'/blog/' + item.fields.postUrl"
            >Read More</router-link
          >
        </p>
      </div>
    </div>
    <!-- <h3 class="mt-5">Tags</h3>
    <hr />
    <blog-tags :tags="tags" /> -->
  </div>
</template>

<script>
import { BlogTags } from "../components";
import { mapState } from "vuex";

export default {
  name: "blog-sidebar",
  // components: {
  //   BlogTags,
  // },
  data() {
    return {
      posts: [],
      month: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
    };
  },
  methods: {
    getDate(date) {
      const d = new Date(date);
      return `${
        this.month[d.getUTCMonth()]
      } ${d.getUTCDate()}, ${d.getUTCFullYear()}`;
    },
    getRandomFeaturedArtist(num) {
      const artistsArray = this.allFeaturedArtists.slice(0);
      const shuffled = this.shuffle(artistsArray);
      return shuffled.slice(0, num);
    },
    shuffle(array) {
      var currentIndex = array.length,
        temporaryValue,
        randomIndex;

      // While there remain elements to shuffle...
      while (0 !== currentIndex) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }

      return array;
    },
  },
  mounted() {
    this.$store.dispatch("getFeaturedArtists").then(() => {
      if (this.randomFeaturedArtists.length === 0) {
        const featuredArtists = this.getRandomFeaturedArtist(3);
        this.$store.commit("randomFeaturedArtists", featuredArtists);
      }
    });
    if (this.top12.length < 12) this.$store.dispatch("getTop12");
  },
  computed: {
    ...mapState([
      "randomFeaturedArtists",
      "top12",
      "totalCount",
      "allFeaturedArtists",
    ]),
    tags() {
      let tags = [];

      this.posts.forEach((post) => {
        if (post.fields.tags.length > 0) {
          tags = [...tags, ...post.fields.tags];
        }
      });
      return [...new Set([...tags])];
    },
  },
  created() {
    this.$store.dispatch("getTotalCount");
    this.$contentful
      .getEntries({ order: "-sys.createdAt", content_type: "blogPost" })
      .then((response) => {
        this.posts = response.items;
      })
      .catch((err) => console.error(err));
  },
};
</script>

<style lang="scss" scoped>
hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.featured-image {
  a {
    width: 100%;
    padding-top: 100%;
    background-size: cover;
    background-position: center center;
    border-radius: 3px;
    overflow: hidden;
    display: block;
    margin-bottom: 20px;
  }
}

.featured-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 12px;

  .featured-link {
    font-size: 1.2rem;
    margin-left: 12px;
    overflow: hidden;

    a {
      color: #333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      &:hover {
        color: #11cdef;
      }
    }
  }

  .featured-avatar {
    width: 50px;
    min-width: 50px;
    height: 50px;
    overflow: hidden;
    border-radius: 25px;
    background-size: cover;
    background-position: center center;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.recent-posts {
  h4 {
    margin-bottom: 0;
  }

  .date {
    font-size: 0.875rem;
    color: #999999;
  }

  p {
    font-size: 0.875rem;
  }
}

@media (max-width: 575.98px) {
  .sidebar-wrapper {
    margin-top: 4rem;
  }
}
</style>
